import React from 'react';

import BlogCard from './blog-card/blog-card';

import './blogs.styles.scss';

type BlogsProps = {
  articles: GatsbyTypes.StrapiArticlesMetaQuery['allStrapiArticle']['edges'];
};

const Blogs: React.FC<BlogsProps> = ({ articles }) => {
  return (
    <div className="blog ptb-100">
      <div className="container">
        <div className="row">
          {articles.map(
            ({
              node: {
                title,
                strapiId,
                author,
                publishedAt,
                slug,
                image: {
                  publicURL,
                  childImageSharp: {
                    fixed: { src },
                  },
                },
              },
            }) => (
              <div className="col-lg-4 col-md-6" key={strapiId}>
                <BlogCard
                  {...{ title, publishedAt }}
                  url={`/blogs/${slug}`}
                  thumbnailUrl={publicURL}
                  author={{
                    name: author.name,
                    profilePicUrl: author.picture.publicURL || src,
                  }}
                />
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default Blogs;
